import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuoteCardComponent } from './quote-card.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [QuoteCardComponent],
  exports: [QuoteCardComponent],
  imports: [
    CommonModule,
    IonicModule,
    PipesModule
  ]
})
export class QuoteCardModule { }
